import React from 'react';
import { useModal } from '../../context/ModalContext';
import './AddendasAndDevSection.css';

const AddendasAndDevSection = () => {
  const { openModal } = useModal();

  return (
    <section className="df-addendas-dev-section">
      <div className="df-addendas-dev-container">
        {/* Tarjeta 1: Addendas */}
        <div id="addendas" className="df-addendas-card">
          <div className="df-addendas-icon-box">
            <svg
              width="34"
              height="34"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
              <path d="M14 3v6h6M12 12v6M9 15h6"></path>
            </svg>
          </div>

          <div className="df-addendas-content">
            <h3 className="df-addendas-title">Addendas</h3>
            <p className="df-addendas-desc">Contamos con todas las addendas del mercado.</p>
            <button
              type="button"
              className="df-addendas-link"
              onClick={() => openModal('addendas')}
            >
              Conoce las addendas disponibles
            </button>
          </div>
        </div>

        {/* Tarjeta 2: Desarrollo a la medida */}
        <div id="desarrollo" className="df-addendas-card">
          <div className="df-addendas-icon-box">
            <svg
              width="34"
              height="34"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="m8 8-5 4 5 4M16 8l5 4-5 4M14 5l-4 14"></path>
            </svg>
          </div>

          <div className="df-addendas-content">
            <h3 className="df-addendas-title">Desarrollo a la medida</h3>
            <p className="df-addendas-desc">Desarrollo de aplicaciones de escritorio, móviles y web.</p>
            <a
              href="#contacto"
              className="df-addendas-link"
            >
              Contáctanos
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AddendasAndDevSection;
